import React from 'react';
import {
  SectionContainer,
  LeftContainer,
  RightContainer,
  ContentWrapper,
  LogoContainer,
  Title,
  Description,
  SubDescription,
  AdditionalInfo
} from './styles';
import logoImage from '../../../assets/images/logo.png';

const FeatureSection = () => {
  return (
    <SectionContainer>
      <LeftContainer />
      <RightContainer>
        <ContentWrapper>
          <LogoContainer>
            <img src={logoImage} alt="Floqss" />
          </LogoContainer>
          
          <Title>
            Floqss transforma lo digital en acceso real.
          </Title>
          
          <Description>
            Entregamos experiencias digitales directamente en tus manos, sin pagos anticipados ni tarjetas.
          </Description>
          
          <SubDescription>
            Porque el mundo digital también es para quienes siempre quedaron por fuera.
          </SubDescription>
          
          <AdditionalInfo/>
        </ContentWrapper>
      </RightContainer>
    </SectionContainer>
  );
};

export default FeatureSection;